import { createFileRoute } from '@tanstack/react-router'

import { DeclinesScreen } from './-components/declines-screen.tsx'

export const Route = createFileRoute('/risk/declines')({
  component: DeclinesScreen
})
